import React, { Component, Fragment } from 'react';
import Overlay from './Overlay';
import MegamenuMultisitesContent from './Megamenu/MegamenuMultisitesContent';

class NewHeaderCategoriesMultisites extends Component {
  state = { overCategoryItem: false, selectData: { l2subcategories: [] } }

  setOverCategoryItem = stateOver => this.setState({ overCategoryItem: stateOver });

  setSelectData = dataItem => this.setState({ selectData: dataItem });

  renderListItem = (item, index) => {
    const { overCategoryItem } = this.state;
    const selected = (this.state.selectData.id === item.id) && overCategoryItem;

    return (
      <li
        className={selected ? 'selected' : ''}
        key={`${item.id}-${index}`}
        onMouseEnter={() => this.setOverCategoryItem(true)}
        onMouseLeave={() => this.setOverCategoryItem(false)}
      >
        <a
          className="dropItem dataChilds"
          key={item.name}
          rel="noopener noreferrer"
          target="_blank"
          onMouseEnter={() => this.setSelectData(item)}
        >
          {item.name}
        </a>
      </li>
    );
  }

  render() {
    const { overCategoryItem, selectData } = this.state;

    return (
      <div className="headerCategoryMultisite-wrapper">
        <div className="headerCategoryMultisite">
          <ul>
            {
              (this.props.categoryList || []).map(this.renderListItem)
            }
          </ul>
          {
            overCategoryItem && (
              <Fragment>
                <MegamenuMultisitesContent
                  setOverCategoryItem={this.setOverCategoryItem}
                  overCategoryItem={overCategoryItem}
                  selectData={selectData}
                />
                <Overlay
                  styles={{
                    styleTop: '150px',
                    zIndex: 2,
                  }}
                />
              </Fragment>
            )
          }
        </div>
      </div>
    );
  }
}

export default NewHeaderCategoriesMultisites;
